export default __webpack_public_path__ + "static/media/wave.17feefcd.svg";